import {
  DELETE_PLC_SAFETY_EVENT,
  DELETE_PLC_SAFETY_EVENT_SUCCESSFUL,
  DELETE_PLC_SAFETY_EVENT_FAILED,
} from './actionTypes';

export const deletePlcSafetyEvent = (event) => ({
  type: DELETE_PLC_SAFETY_EVENT,
  payload: { event },
});

export const deletePlcSafetyEventSuccessful = (message) => ({
  type: DELETE_PLC_SAFETY_EVENT_SUCCESSFUL,
  payload: message,
});

export const deletePlcSafetyEventFailed = (message) => ({
  type: DELETE_PLC_SAFETY_EVENT_FAILED,
  payload: message,
});
